module.exports = __webpack_public_path__ + "img/topimg.5052020e.png";